var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11V23C29 23.55 28.8042 24.0208 28.4125 24.4125C28.0208 24.8042 27.55 25 27 25H11C10.45 25 9.97917 24.8042 9.5875 24.4125C9.19583 24.0208 9 23.55 9 23V11C9 10.45 9.19583 9.97917 9.5875 9.5875C9.97917 9.19583 10.45 9 11 9H27C27.55 9 28.0208 9.19583 28.4125 9.5875C28.8042 9.97917 29 10.45 29 11ZM11 13H27V11H11V13ZM11 17V23H27V17H11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2ZM2 4H18V2H2V4ZM2 8V14H18C18 14 18 11 18 8H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1117eb71820f46475bff62a080905602.svg";
export { ForwardRef as ReactComponent };